<template>
  <v-card class="pa-2">
    <v-row dense>
      <v-col cols="12">
        <sf-heading class="mb-1">
          {{ $t('user.settings.settings') }}
        </sf-heading>
      </v-col>
      <!-- order right -->
      <v-col cols="12" md="6" lg="4">
        <div class="d-flex flex-row align-center mb-1">
          <sf-sub-heading class="mr-2">
            {{ $t('user.settings.allowTracking') }}
          </sf-sub-heading>
          <v-switch
            v-model="userSettings.allowTracking"
            class="mt-0 pt-0"
            inset
            color="green"
            hide-details
            :aria-label="$t('user.settings.allowTracking')"
            @update:model-value="updateAllowTracking"
          />
        </div>
        <div class="text-justify">
          <sf-text>
            {{ $t('user.settings.allowTrackingDescription') }}
          </sf-text>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script setup lang="ts">
import SfHeading from '@/components/text/SfHeading.vue'
import SfSubHeading from '@/components/text/SfSubHeading.vue'
import SfText from '@/components/text/SfText.vue'
import { User } from '@/generatedTypes'
import useOwnUser from '@/modules/user/useOwnUser'
import { computed, PropType } from 'vue'

const props = defineProps({
  user: {
    type: Object as PropType<User>,
    required: true
  }
})

const userSettings = computed(() => {
  return {
    allowTracking: props.user.setting.allowTracking
  }
})

const updateAllowTracking = (value: boolean | null) => {
  if (typeof value === 'boolean') {
    useOwnUser().updateAllowTracking(value)
  }
}
</script>
